module.exports = __webpack_public_path__ + "4.png?dd77cc9a389082233e62920ec8b28c40";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scss/inspinia/patterns/4.png
// module id = 167
// module chunks = 0